const RANKS = [
  { no: 1, hot: 96, text: "某头部主播工作室连夜清空简介，网友猜了一个通宵", type: "圈子内幕", delta: "↑" },
  { no: 2, hot: 88, text: "散伙饭完整名单流出，谁到场谁缺席一目了然", type: "好友八卦", delta: "↑" },
  { no: 3, hot: 79, text: "平台年度规则暗改一处措辞，恰是争议最集中的那句", type: "行业爆料", delta: "新" },
  { no: 4, hot: 71, text: "道歉长文删了又发，配图前后对不上被做成对比", type: "幕后闹剧", delta: "↑" },
  { no: 5, hot: 63, text: "饭圈控评话术模板被扒，同一句话出现几十次", type: "饭圈谈资", delta: "→" },
];

export default function HotRanking() {
  return (
    <section id="ranking" className="bg-background-100">
      <div className="mx-auto max-w-6xl px-4 py-12 md:px-6 md:py-16">
        <div className="grid gap-8 lg:grid-cols-12">
          {/* ranking */}
          <div className="lg:col-span-7">
            <div className="flex items-center gap-3">
              <span className="flex h-9 items-center gap-1.5 rounded-md bg-primary-500 px-3 text-sm font-bold text-background-50">
                <i className="ri-fire-fill" aria-hidden="true"></i>
                热度
              </span>
              <h3 className="font-heading text-2xl font-black text-foreground-950 md:text-3xl">
                今日热度榜
              </h3>
            </div>

            <ol className="mt-6 divide-y divide-foreground-200/60 border-y border-foreground-200/60">
              {RANKS.map((r) => (
                <li key={r.no} className="group flex items-center gap-4 py-4">
                  <span
                    className={`font-heading text-3xl font-black md:text-4xl ${
                      r.no === 1 ? "text-primary-600" : "text-foreground-300"
                    }`}
                  >
                    {String(r.no).padStart(2, "0")}
                  </span>
                  <div className="min-w-0 flex-1">
                    <div className="flex items-center gap-2">
                      <span className="whitespace-nowrap rounded bg-secondary-200/80 px-2 py-0.5 text-xs text-secondary-900">
                        {r.type}
                      </span>
                      <span
                        className={`whitespace-nowrap text-xs font-bold ${
                          r.delta === "↑"
                            ? "text-primary-600"
                            : r.delta === "新"
                              ? "text-accent-700"
                              : "text-foreground-500"
                        }`}
                      >
                        {r.delta}
                      </span>
                    </div>
                    <h4 className="mt-1 truncate font-heading text-base font-bold leading-snug text-foreground-900 group-hover:text-primary-700 md:text-lg">
                      <a href="#comment">{r.text}</a>
                    </h4>
                  </div>
                  <div className="hidden flex-col items-end gap-1 sm:flex">
                    <span className="text-sm font-bold text-primary-700">{r.hot}</span>
                    <div className="h-1.5 w-24 overflow-hidden rounded-full bg-foreground-200/70">
                      <div
                        className="h-full rounded-full bg-accent-500"
                        style={{ width: `${r.hot}%` }}
                      ></div>
                    </div>
                  </div>
                </li>
              ))}
            </ol>
          </div>

          {/* aside heat pulse */}
          <div className="lg:col-span-5">
            <div className="rounded-lg border border-foreground-200/60 bg-foreground-950 p-6 text-background-100 md:p-7">
              <p className="text-xs font-semibold tracking-[0.3em] text-accent-400">HEAT PULSE</p>
              <h4 className="mt-2 font-heading text-2xl font-black text-background-50">
                此刻正在发酵
              </h4>
              <div className="mt-5 space-y-4">
                {[
                  { k: "圈内关键词", v: "保密协议 / 散伙 / 名单", pct: 100 },
                  { k: "跨平台热度", v: "微博 + 论坛 + 社群", pct: 82 },
                  { k: "参与度", v: "转发评论 24h +168%", pct: 74 },
                ].map((b) => (
                  <div key={b.k}>
                    <div className="flex items-center justify-between text-sm">
                      <span className="text-background-100/80">{b.k}</span>
                      <span className="font-medium text-background-50">{b.v}</span>
                    </div>
                    <div className="mt-1.5 h-2 overflow-hidden rounded-full bg-background-100/15">
                      <div
                        className="h-full rounded-full bg-accent-500"
                        style={{ width: `${b.pct}%` }}
                      ></div>
                    </div>
                  </div>
                ))}
              </div>
              <div className="mt-6 border-t border-background-100/15 pt-4 text-sm leading-relaxed text-background-100/70">
                榜单每 30 分钟刷新一次，代表当前成人吃瓜圈子内幕、好友八卦与行业爆料在多个平台的真实声量。
              </div>
              <a
                href="#zones"
                className="mt-5 inline-flex items-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-4 py-2.5 text-sm font-medium text-background-50 hover:bg-primary-400"
              >
                <i className="ri-chat-3-line" aria-hidden="true"></i>
                加入讨论
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}